import { useEffect, useState, useMemo } from 'react';
import { sideBarAdminMenuList } from 'utils';
import { Grid, Button } from 'components';
import { menuVisibilityGridColumns } from '../utils'; 

interface Props {
  searchValue?: string;
}

const MenuVisibilityTab = ({ searchValue }: Props) => {

  const flatMenuList = sideBarAdminMenuList.flatMap(menu => menu.children);

  // * 대소문자 구분 없이 검색
  const filteredMenuList = useMemo(() => {
    if (!searchValue) return flatMenuList;
    
    return flatMenuList.filter(menu => 
      menu.title.toLowerCase().includes(searchValue.toLowerCase())
    );
  }, [flatMenuList, searchValue]);

  const [visibilityMap, setVisibilityMap] = useState<Record<string, { user?: boolean; admin?: boolean }>>(() => {
    const saved = localStorage.getItem('menuVisibility');
    return saved ? JSON.parse(saved) : {};
  });

  const [checkedRows, setCheckedRows] = useState<number[]>([]);

  // * 메뉴 표시 토글 함수
  function toggleVisibility(path: string, role: 'user' | 'admin') {
    setVisibilityMap(prev => {
      const updated = {
        ...prev,
        [path]: {
          ...prev[path],
          [role]: !prev[path]?.[role]
        }
      };
      localStorage.setItem('menuVisibility', JSON.stringify(updated));
      return updated;
    });
  }

  return (
    <>
      <Grid
        className="w-full overflow-x-auto overflow-y-auto px-6 pb-6 [&_th:first-child]:pr-2 [&_td:first-child]:pr-2"
        gridColumns={menuVisibilityGridColumns}
        gridData={filteredMenuList}
        searchValue={searchValue}
        checkedRows={checkedRows}
        setCheckedRows={setCheckedRows}
        options={{
          useFilter: true,
          useSearch: {
            use: false, 
            searchKeys: ['title']
          },
          useCheckbox: false,
          customCell: {
            user: (_, row) => (
              <input
                type="checkbox"
                className="w-4 h-4 accent-primary cursor-pointer"
                checked={visibilityMap[row.path]?.user ?? true}
                onChange={() => toggleVisibility(row.path, 'user')}
              />
            ),
            admin: (_, row) => (
              <input
                type="checkbox"
                className="w-4 h-4 accent-primary cursor-pointer"
                checked={visibilityMap[row.path]?.admin ?? true}
                onChange={() => toggleVisibility(row.path, 'admin')}
              />
            )
          }
        }}
      />
    </>
  );
};

export default MenuVisibilityTab;
